import {
	useAuthService,
} from 'services';
import {
	useNavigate,
} from 'react-router-dom';
import {
	ContentViews,
} from 'utils/navigation/Navigation';

interface AuthenticateProps {
  login: JSX.Element,
  children: JSX.Element,
}

/**
 * Authentication
 * @param login
 * @param children
 * @constructor
 */
const Authenticate = (
	{
		login, children,
	}: AuthenticateProps,
) => {
	const navigate = useNavigate();
	const {
		isAuthenticated,
		isLoading,
	} = useAuthService();

	if (isLoading) {
		return (
			<div>
        Autentiserer…
			</div>
		);
	}
	if (isAuthenticated) {
		if (window.location.pathname === ContentViews.LOGIN.path) {
			navigate(ContentViews.TRANSPORT.path);
		}
		return (children);
	}
	else {
		return (login) ;
	}
}

export default Authenticate;